import React, { useState, useEffect } from 'react';
import classnames from 'classnames';
import MaskedInput from 'react-text-mask';
import { danger } from 'scy/text/styles.mod.scss';
import margin from 'scy/margin.mod.scss';
import styles from './styles.mod.scss';

export default function FormField({
  initialValue = '',
  updatedValue,
  error,
  onChange,
  validate,
  id,
  name,
  labelText,
  inputType = 'text',
  placeholder,
  mask,
  textarea,
  inputRef,
  autoFocus,
  disabled,
  autocomplete,
  className,
  marginClass
}) {
  const [value, setValue] = useState(initialValue);
  const [errorMsg, setErrorMsg] = useState(error);
  const [hasFocus, setHasFocus] = useState(false);
  const [autofilled, setAutofilled] = useState(false);

  useEffect(() => {
    setErrorMsg(error);
  }, [error]);

  useEffect(() => {
    if (typeof updatedValue !== 'undefined') {
      setValue(updatedValue);
      setErrorMsg(null);
    }
  }, [updatedValue]);

  function handleChange(e) {
    e.preventDefault();
    const value = e.target.value;
    setValue(value);
    if (onChange) onChange(value);
  }

  function handleFocus() {
    setHasFocus(true);
  }

  function handleBlur() {
    setHasFocus(false);
    if (validate) {
      const error = validate(value) || null;
      setErrorMsg(error);
    }
  }

  function handleAutofill({ animationName }) {
    switch (animationName) {
      case 'onAutoFillCancel':
        setAutofilled(false);
        break;
      case 'onAutoFillStart':
        setAutofilled(true);
        break;
    }
  }

  const isFloating = !!value || hasFocus || !!errorMsg || autofilled;

  const inputClass = classnames(styles.input, {
    [styles.floatingInput]: isFloating
  });

  return (
    <div
      className={classnames(
        styles.container,
        marginClass || margin.bottom_sm,
        className,
        {
          [styles.inputContainer]: !textarea,
          [styles.textareaContainer]: !!textarea,
          [styles.errorBorder]: !!errorMsg,
          [styles.disabled]: disabled
        }
      )}
    >
      <label
        htmlFor={id}
        className={classnames(styles.label, {
          [styles.floatingLabel]: isFloating,
          [danger]: !!errorMsg
        })}
      >
        {errorMsg || labelText}
      </label>

      {textarea ? (
        <textarea
          id={id}
          className={classnames(inputClass, styles.textareaInput)}
          maxLength="300"
          value={value}
          onChange={handleChange}
          onFocus={handleFocus}
          onBlur={handleBlur}
          ref={inputRef}
          autoFocus={autoFocus}
        />
      ) : mask ? (
        <MaskedInput
          mask={mask}
          id={id}
          name={name}
          className={inputClass}
          type={inputType}
          placeholder={(isFloating && placeholder) || ''}
          disabled={disabled}
          value={value}
          onChange={handleChange}
          onFocus={handleFocus}
          onBlur={handleBlur}
        />
      ) : (
        <input
          id={id}
          name={name}
          className={inputClass}
          type={inputType}
          placeholder={(isFloating && placeholder) || ''}
          disabled={disabled}
          autoComplete={autocomplete}
          value={value}
          onChange={handleChange}
          onFocus={handleFocus}
          onBlur={handleBlur}
          onAnimationStart={handleAutofill}
          ref={inputRef}
          autoFocus={autoFocus}
        />
      )}
    </div>
  );
}
